export default {
    requestError: 'requestError',
    loading: 'loading',
    unauthorize: 'unauthorize', //sagar add this event 13-07-2023 when user change route manually authorize and unauthorize page show based on  request
};